function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M200 688h600c23-1 44 11 55 30 11 20 11 44 0 64-11 19-32 31-55 30H200c-23 1-44-11-55-30-11-20-11-44 0-64 11-19 32-31 55-30m0-251h600c23 0 44 12 55 31 11 20 11 44 0 64-11 19-32 31-55 31H200c-23 0-44-12-55-31-11-20-11-44 0-64 11-19 32-31 55-31m0-249h600c23-1 44 11 55 30 11 20 11 44 0 64-11 19-32 31-55 30H200c-23 1-44-11-55-30-11-20-11-44 0-64 11-19 32-31 55-30"
});

function SvgHamburgerMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    style: {
      maxWidth: "1.6em",
      height: "auto"
    }
  }, props), _ref);
}

export default SvgHamburgerMenu;